(() => {
'use strict';
class ContentToc extends HTMLElement {
  connectedCallback() {
    if (this.dataset.ready) return;
    this.dataset.ready = 'true';
    const body = document.getElementById(this.dataset.target);
    const list = this.querySelector('ol');
    const headings = body?.querySelectorAll('h2') || [];
    if (!headings.length) { this.hidden = true; return; }
    headings.forEach((heading, index) => {
      if (!heading.id) heading.id = `${this.dataset.target}-heading-${index + 1}`;
      const li = document.createElement('li');
      const link = document.createElement('a');
      link.href = `#${heading.id}`;
      link.textContent = heading.textContent;
      li.append(link); list.append(li);
    });
    const details = this.querySelector('details');
    if (details) details.open = window.matchMedia('(min-width: 750px)').matches;
  }
}
if (!customElements.get('content-toc')) customElements.define('content-toc', ContentToc);

})();
